import type { FilterOption } from "./types";

export const toggleSelection = <T,>(selected: T[], value: T): T[] => {
  if (selected.includes(value)) {
    return selected.filter((item) => item !== value);
  }
  return [...selected, value];
};

export const getSelectedSummary = <T extends string | number>(
  selected: T[],
  options: Array<FilterOption<T>>,
  allLabel: string
) => {
  if (!selected.length) return allLabel;
  if (selected.length === 1) {
    const option = options.find((o) => o.value === selected[0]);
    return option?.label || allLabel;
  }
  return `${selected.length} selected`;
};

export const getSelectedPreview = <T extends string | number>(
  selected: T[],
  options: Array<FilterOption<T>>,
  allLabel: string
) => {
  if (!selected.length) return `Showing ${allLabel.toLowerCase()}`;
  const labels = options
    .filter((option) => selected.includes(option.value))
    .map((option) => option.label);
  if (labels.length <= 2) return labels.join(", ");
  return `${labels[0]}, ${labels[1]} +${labels.length - 2}`;
};
